import { WarehouseAxios } from "api/WarehouseAxios";
import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Table, Button, Spinner } from "react-bootstrap";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

type transferRequestDataType = {

  stock_transfer_no: string,
  transferDate: string, 
  transferFrom: string,
  warehouse_type: string,
  transferTo: string,
  initiatedBy: string,
  approvedBy: string,
  approvedDate: string,

}
const ViewTransferRequest = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { id } = useParams();
  const isEdit = Boolean(id);
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [transferRequestData, setTransferRequestData] = useState<transferRequestDataType>();

  // const data = [
  //   {
  //     id: 1,
  //     sr_no: 1,
  //     item_name: "Route Indicator",
  //     request_quality: 100,
  //     quantity: 70,
  //     unit: "Nos",
  //     unit_price: 800,
  //     flat_percentage: 5,
  //     discount_value: "Percentage",
  //     net_price: 76000,
  //     gst: 40000,
  //     sgst: 450,
  //     cgst: 450,
  //     camount: 450,
  //     total: 4950,
  //   },
  //   {
  //     id: 2,
  //     sr_no: 2,
  //     item_name: "Route Indicator",
  //     request_quality: 100,
  //     quantity: 70,
  //     unit: "Nos",
  //     unit_price: 800,
  //     flat_percentage: 5,
  //     discount_value: "Percentage",
  //     net_price: 76000,
  //     gst: 40000,
  //     sgst: 450,
  //     cgst: 450,
  //     camount: 450,
  //     total: 4950,
  //   },
  // ];

  useEffect(() => {


    async function fetchDataById() {
      try {
        setLoading(true)
        const resp = await WarehouseAxios.get(`/stock/${id}/get/`)
        const respData = resp.data.data
        setData(respData.transferitems)
        setTransferRequestData({
          stock_transfer_no: respData.stock_transfer_id,
          transferDate: respData.transfer_date,
          transferFrom: respData.transferred_from_name,
          warehouse_type: respData.warehouse_type ? `${respData.warehouse_type}` : `-`,
          transferTo: respData.transferred_to_name,
          initiatedBy: respData.initiated_by,
          approvedBy: respData.approvedBy ? `${respData.approvedBy}` : `-`,
          approvedDate: respData.approvedDate ? `${respData.approvedDate}` : `-`,

        })
      } catch (err: any) {
        toast.error("Unable To fetch Data")
      } finally {
        setLoading(false)
      }
    }
    fetchDataById()

  }, [id])



  const handleCopy = (text: string) => {
    navigator.clipboard.writeText(text);
  };

  return (
    <div className="page-content">
      {
        loading ? <div
          className="text-center py-5"
          style={{
            background: "#fff",
            borderRadius: "10px",
            padding: "30px",
            boxShadow: "0 0 15px rgba(0,0,0,0.05)",
          }}
        >
          <Spinner animation="border" variant="primary" />
        </div> : <Container fluid>
          <Row id="invoiceList">
            <Col lg={12}>
              <Card>
                <Card.Header>
                  <Row className="align-items-center g-2">
                    {/* <Col lg="auto">
                      <Link
                        to="/warehouse-transfer-request"
                        style={{ color: "inherit", textDecoration: "none" }}
                      >
                        <i
                          className="bi bi-arrow-left"
                          style={{ fontSize: "1.2rem", cursor: "pointer" }}
                          aria-label="Back to Purchase Request"
                        />
                      </Link>
                    </Col> */}
                    {/* <Col lg={3} className="me-auto" style={{ paddingLeft: "1%" }}>
                      <h6 className="card-title mb-0">View Details</h6>
                    </Col> */}

                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2 mb-3">
                      {/* Left: Back icon and heading */}
                      <div className="d-flex align-items-center gap-2">
                        <span
                          style={{ fontSize: "24px", cursor: "pointer" }}
                          onClick={() => navigate(-1)}
                        >
                          ←
                        </span>
                        <h5 className="mb-0 fw-bold">
                          View Details
                        </h5>
                      </div>

                      {/* Right: Breadcrumb */}
                      <div className="text-muted">
                        <Link
                          to="/warehouse-transfer-request"
                          style={{ color: "inherit", textDecoration: "none" }}
                        >
                          Warehouse
                        </Link>{" "}
                        &gt;{" "}
                        <Link
                          to="#"
                          onClick={(e: any) => {
                            e.preventDefault();
                          }}
                          style={{ color: "inherit", textDecoration: "none" }}
                        >
                          View Details
                        </Link>
                      </div>
                    </div>
                  </Row>
                </Card.Header>

                <Card.Body>
                  <Row className="mb-3">
                    <Col md={6}>
                      <p className="mb-2">
                        <strong>Stock Transfer No. :</strong> {transferRequestData?.stock_transfer_no}
                      </p>
                    </Col>
                    <Col md={6}>
                      <p className="mb-2">
                        <strong>Transfer Date :</strong> {transferRequestData?.transferDate}
                      </p>
                    </Col>
                    <Col md={6}>
                      <p className="mb-2">
                        <strong>Transfer From :</strong> {transferRequestData?.transferFrom}
                      </p>
                    </Col>

                    <Col md={6}>
                      <p className="mb-2">
                        <strong>Location Type :</strong> {transferRequestData?.warehouse_type}
                      </p>
                    </Col>

                    <Col md={6}>
                      <p className="mb-2">
                        <strong>Transfer To :</strong> {transferRequestData?.transferTo}
                      </p>
                    </Col>
                    <Col md={6}>
                      <p className="mb-2">
                        <strong>Initiated By :</strong> {transferRequestData?.initiatedBy}
                      </p>
                    </Col>

                    <Col md={6}>
                      <p className="mb-2">
                        <strong>Approved By :</strong> {transferRequestData?.approvedBy}
                      </p>
                    </Col>
                    <Col md={6}>
                      <p className="mb-2">
                        <strong>Approved Date:</strong> {transferRequestData?.approvedDate}
                      </p>
                    </Col>
                    {/* <Col md={6}>
                    <p className="mb-2">
                      <strong>PR Attachment :</strong>{" "}
                      <a
                        href={purchaseInfo.rfq_attachment}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          textDecoration: "underline",
                          color: "#0d6efd",
                        }}
                      >
                        Download File
                      </a>
                    </p>
                  </Col>

                  <Col md={6}>
                    <p className="mb-2">
                      <strong>Term & Condition :</strong>{" "}
                      {purchaseInfo.term_and_condition}
                    </p>
                  </Col> */}
                  </Row>

                  {/* <hr /> */}

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    {/* <span>Supplier</span> */}
                    {/* <span
                    style={{
                      backgroundColor: "green",
                      color: "white",
                      padding: "2px 8px",
                      borderRadius: "4px",
                    }}
                  >
                    Registered
                  </span> */}
                  </div>

                  {/* <Row className="mb-3">
                  <Col md={6}>
                    <p className="mb-2">
                      <strong>Transfer Date:</strong>{" "}
                      {purchaseInfo.supplier_name}
                    </p>
                  </Col>
                  <Col md={6}>
                    <p className="mb-2">
                      <strong>Location Type :</strong>{" "}
                      {purchaseInfo.contact_person}
                    </p>
                  </Col>

                  <Col md={6}>
                    <p className="mb-2">
                      <strong>Initiated By :</strong> {purchaseInfo.phone_no}
                    </p>
                  </Col>

                  <Col md={6}>
                    <p className="mb-2">
                      <strong>Approved By:</strong>{" "}
                      {purchaseInfo.contact_person_phone_no}
                    </p>
                  </Col>
                  <Col md={6}>
                    <p className="mb-2">
                      <strong>Company Email :</strong>{" "}
                      {purchaseInfo.company_email}
                    </p>
                  </Col>

                  <Col md={6}>
                    <p className="mb-2">
                      <strong>Contact Person Email :</strong>{" "}
                      {purchaseInfo.contact_person_email}
                    </p>
                  </Col>
                </Row> */}
                  {/* <span className="fw-bold text-dark px-2 py-2">
                  Supplier Item
                </span> */}

                  <div className="mb-2" style={{ overflowX: "auto" }}>
                    <table className="table">
                      <thead className="table-light">
                        <tr>
                          {/* <th>Sr No.</th> */}
                          <th style={{ minWidth: "150px" }}>Item Name</th>
                          {/* <th style={{ minWidth: "150px" }}>Request Quality</th> */}
                          {/* <th style={{ minWidth: "150px" }}>Quantity</th> */}
                          <th style={{ minWidth: "150px" }}>Unit</th>
                          <th style={{ minWidth: "150px" }}>Transfer Quantity</th>
                          <th style={{ minWidth: "150px" }}>Make</th>
                          <th style={{ minWidth: "150px" }}>Model</th>
                          <th style={{ minWidth: "150px" }}>Category</th>
                          <th style={{ minWidth: "150px" }}>Sub Category</th>
                          <th style={{ minWidth: "150px" }}>Remarks</th>
                          {/* <th>SGST %</th>
                      <th>CGST %</th>
                      <th>GST Amount</th>
                      <th>Total</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {data.map((item: any) => (
                          <tr key={item.id}>
                            <td>{item?.item_details?.item_name ?? '-'}</td>
                            <td>{item?.item_details?.unit ?? '-'}</td>
                            <td>{item?.transfer_quantity ?? '-'}</td>
                            <td>{item?.make ?? '-'}</td>
                            <td>{item?.model ?? '-'}</td>
                            <td>{item?.item_details?.category ?? '-'}</td>
                            <td>{item?.item_details?.sub_category ?? '-'}</td>
                            <td>{item?.remarks ? item.remarks : '-'}</td>
                          </tr>

                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="d-flex justify-content-center gap-3 py-3">

                    <Link
                      to="/warehouse-transfer-request"
                      className="text-decoration-none"
                      style={{ color: "#495057" }}
                    >
                      <Button
                        variant="light"
                        style={{
                          border: "1px solid #ced4da",
                          // backgroundColor: "white",
                        }}
                      >
                        Back
                      </Button>

                    </Link>

                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      }

    </div>
  );
};

export default ViewTransferRequest;
